import React from 'react'
import HeroSection from '../OutletTemplate/HeroSection'
import CaseStudiesSection from '../HomeLanding/ComponentsIndiaPage/CaseStudiesSection'
import NewFaqSection from '../HomeLanding/HomeLandingComponents/NewFaqSection'
import NewsAndVideos from '../HomeLanding/ComponentsIndiaPage/NewsAndVideos'
import FeaturesSection from '../OutletTemplate/FeaturesSection'
import styles from '../.././styles/outletTemplate.module.css'
import GetFreeTrial from '../OutletTemplate/GetFreeTrial'
import ReviewsSection from '../HomeLanding/ComponentsIndiaPage/ReviewsSection'
import BusinessUnlockSection from '../HomeLanding/ComponentsIndiaPage/BusinessUnlockSection'
import ConnectWithUs from '../HomeLanding/ComponentsIndiaPage/ConnectWithUs'
import { MarqueeComponentHomePage, NewMarqueeComponentHomePageIndia } from '../qbStrap'
import Image from 'next/image'

const FashionWatchesStore = () => {
    const topSection = [
        {
            title: <>POS Billing Software for Fashion Watch Stores</>,
            text: "Every great timepiece deserves a technology that runs like clockwork. QueueBuster’s POS Billing Software for Fashion Watch Stores helps you manage everything, from billing and stock to offers and customer loyalty, with just a few taps. Say goodbye to slow checkouts and stock confusion, and say hello to a smooth, stylish shopping experience. ",
            centerImage: "/assets/watchStore/watch_center_img.webp",
            height: "32rem",
            width: "53.6rem",
            top: "-17rem",

            Image1: {
                src: "/assets/watchStore/stocks.svg",
                alt: "Watch Store Image 1",
                width: "15rem",
                height: "6rem",
                left: "9rem",
                bottom: "18rem",


            },
            Image2: {
                src: "/assets/watchStore/quick_bill.svg",
                alt: "Watch Store Image 2",
                width: "12rem",
                height: "13rem",
                bottom: "24rem",
                left: "30rem",

            },
            Image3: {
                src: "/assets/watchStore/Schedule.svg",
                alt: "Watch Store Image 3",
                width: "22rem",
                height: "8rem",
                bottom: "25rem",
                right: "22rem",

            },
            Image4: {
                src: "/assets/watchStore/mensWatch.svg",
                alt: "Watch Store Image 4",
                width: "13rem",
                height: "13rem",
                bottom: "15rem",
                right: "6rem",

            },
            Image5: {
                src: "/assets/watchStore/gift.svg",
                alt: "Watch Store Image 5",
                width: "4rem",
                height: "4rem",
                bottom: "28rem",
                left: "23rem",

            },


        }
    ]

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                  Why is this POS software good for fashion watch stores?
                </span>
            ),
            des: "Because it’s made to handle everything, from fast billing and detailed stock tracking to customer loyalty and offers. It keeps your business stylish and smart.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I track different types of watches separately?
                </span>
            ),
            des: "Yes. You can manage inventory for smart watches, digital, and luxury brands with different categories.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                  Can I run offers or discounts easily?
                </span>
            ),
            des: "Absolutely! Create offers for festive seasons, or combo deals. Set them once and let our software handle the rest.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Does it support both small stores and large chains?
                </span>
            ),
            des: "Yes. Whether you have one store or many, this POS software works perfectly and gives you central control over everything.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Which payment methods does it support?
                </span>
            ),
            des: "You can accept UPI, credit/debit cards, wallets, and cash. Multiple payment options are available in one place.",
            id: 5,
            activeIndex: 0,
        },

    ]
    const watchStoreFeatures = {
        // centerImage1: "/assets/watchStore/Center_image_watchStore.webp",
        centerImage2: "/assets/watchStore/watchStore_image.webp",
        data: [
            {
                id: 1,
                image: "/assets/watchStore/easy_billing.webp",
                icon: "/assets/petStore/Point_of_sale.svg",
                title: "Quick and easy billing for fashion watches",
                tag: "Point of Sale",
                desc: "This POS is built to handle the fast-moving world of fashion watch stores. Whether you sell in-store or online, it keeps your billing smooth and professional.",
                btnText: "Speak with an expert",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                Image1: {
                    src: "/assets/watchStore/collection.svg",
                    alt: "watch Store Image",
                    imageWidth: "14rem",
                    imageHeight: "16rem",
                    top: "3rem",
                    right: "3rem",
                },
                 
                

                Image4: {
                    src: "/assets/watchStore/discount.svg",
                    alt: "Pet Store Image 2",
                    imageWidth: "20rem",
                    imageHeight: "9rem",
                    left: "-3rem",
                    bottom: "4rem",

                },
               

                points: [
                    <>
                        Fast billing for single or multiple items.
                    </>,
                    <>
                       Accept UPI, cards, cash, or wallet payments
                    </>,
                    <>
                        Easy returns and exchanges with full records.
                    </>,
                ],
            },
            {
                id: 2,
                image: "/assets/watchStore/trackofwatch.webp",
                tag: "Inventory Management",
                icon: "/assets/petStore/Inventory.svg",
                title: "Keep track of every watch, strap, and box",
                desc: "Stay updated with your inventory, whether it’s the latest smart watch or a luxury watch. Avoid running out of popular styles or over stocking old ones.",
                btnText: "Request a callback",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                 Image1: {
                    src: "/assets/watchStore/SalesTargetAchievement.svg",
                    imageWidth: "26rem",
                    imageHeight: "18rem",
                    bottom: "-4rem",
                    right: "1rem",
                     
                },
                Image3: {
                    src: "/assets/watchStore/alart.svg",
                    alt: "Pet Store Image 2",
                    imageWidth: "20rem",
                    imageHeight: "8rem",
                    left: "0rem",
                    top: "9rem",
                },
                
                 

                points: [
                    <>
                        Track watch models, sizes, and colors in real-time.
                    </>,
                    <>
                        Set alerts when stock is low.
                    </>,
                    <>
                        Manage stock for straps, watch cases, and other add-ons.
                    </>,
                    <>Record batch details and warranty periods.</>,
                    <>Easily manage suppliers and purchase orders.</>
                ],
            },
            {
                id: 3,
                image: "/assets/watchStore/Sell_from_anywhere.webp",
                tag: "Mobile & In-store orders",
                icon: "/assets/petStore/loyalty_new.svg",
                 title: "Sell from anywhere with ease",
                desc: "With our POS software, your staff can assist customers using a tablet or mobile since it’s android-based. No need to make them wait at the counter.",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                btnText: "Talk to an expert",
                Image1: {
                    src: "/assets/watchStore/Analogue.svg",
                    alt: "watch Store Image 4",
                    imageWidth: "16rem",
                    imageHeight: "16rem",
                    top: "5rem",
                    right: "8rem",
                    
                },
                Image3: {
                    src: "/assets/watchStore/Johnathan.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "22rem",
                    imageHeight: "16rem",
                    bottom: "-3rem",
                    left: "0rem",
                     
                },
                
                
                points: [
                    <>Take orders and bill right on the spot.</>,
                    <>Faster checkouts and better service.</>,
                    <> Print or send digital invoices instantly.</>,
                    <>Reduce queue time during festive rush</>
                ],
            },
            {
                id: 4,
                image: "/assets/watchStore/selling.webp",
                tag: "Reports & Analytics",
                icon: "/assets/petStore/online-shop.svg",
                title: "Know what’s selling and what’s not",
                desc: "Make smarter decisions with clear reports on sales, stock, and staff performance. Everything you need to grow your business is right at your fingertips.",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                btnText: "Request a callback",
                
                Image1: {
                    src: "/assets/watchStore/gst_returns.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "24rem",
                    imageHeight: "8rem",
                    bottom: "6rem",
                    right: "-3rem",
                    
                },
                 Image3: {
                    src: "/assets/watchStore/Sales&Purchase.svg",
                    alt: "Watch Store Image 4",
                    imageWidth: "15rem",
                    imageHeight: "16rem",
                    top: "2rem",
                    left: "7rem",
                    
                },
                Image4: {
                    src: "/assets/watchStore/sale.svg",
                    alt: "Pet Store Image 3",
                    imageWidth: "22rem",
                    imageHeight: "8rem",
                    bottom: "0rem",
                    left: "0rem",
                     
                },


                points: [
                    <>See top-selling watch brands and styles.</>,
                    <>Track sales by day, staff, or store section.</>,
                    <>Monitor customer foot fall and peak shopping hours.</>,
                    <>View GST reports in one click.</>,
                    <>Get daily or weekly summaries over email.</>
                ],
            },
              {
                id: 5,
                image: "/assets/watchStore/loyal_customers.webp",
                tag: "Loyalty & CRM",
                icon: "/assets/petStore/loyalty_new.svg",
                title: "Turn first-time buyers into loyal customers",
                desc: "Build strong relationships with your customers. Offer them points, perks, and reasons to return again. Surprise them with special offers on birthdays, early access to sales, and VIP benefits for frequent purchases.",
                imageWidth: "42rem",
                imageHeight: "40.3rem",
                btnText: "Request a callback",
                Image1: {
                    src: "/assets/watchStore/ArmaniExchange.svg",
                    alt: "Watch Store Image 4",
                    imageWidth: "22rem",
                    imageHeight: "14rem",
                    top: "3rem",
                    right: "0rem",
                    
                },
                Image3: {
                    src: "/assets/watchStore/Celebrate.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "26rem",
                    imageHeight: "6rem",
                    bottom: "6rem",
                    left: "4rem",
                   
                    
                },
                

                points: [
                    <>Store customer data and purchase history.</>,
                    <>Run loyalty programs with points or special offers.</>,
                    <>Get repeat visits through customized messages.</>,
                     
                ],
            },
        ]
    };
     const CompanyLogos = [
    { imgSrc: "/assets/HomeLanding/QBIcons/heineken.svg", height:"10rem",width:"15rem", altText: "Heineken" },
    { imgSrc: "/assets/HomeLanding/QBIcons/bridgestone.svg",height:"10rem",width:"15rem", altText: "Bridgestone" },
    { imgSrc: "/assets/HomeLanding/QBIcons/itc.svg",height:"10rem",width:"15rem", altText: "ITCLimited" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tajseats.svg",height:"10rem",width:"15rem", altText: "TajSats1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/irctc.svg",height:"10rem",width:"15rem",  altText: "irctc" },
    { imgSrc: "/assets/HomeLanding/QBIcons/cremica.svg",height:"10rem",width:"15rem",  altText: "Cremica" },
    { imgSrc: "/assets/HomeLanding/QBIcons/pansarigroup.svg",height:"10rem",width:"15rem",  altText: "PansariGroup" },
    { imgSrc: "/assets/HomeLanding/QBIcons/reshamandi.svg",height:"10rem",width:"15rem",  altText: "Reshamandi1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/selectcitywalk.svg",height:"10rem",width:"15rem", altText: "SelectCitywalk" },
    { imgSrc: "/assets/HomeLanding/QBIcons/cococart.svg",height:"10rem",width:"15rem", altText: "Cococart" },
    { imgSrc: "/assets/HomeLanding/QBIcons/emoi.svg",height:"10rem",width:"15rem", altText: "Emoi" },
    { imgSrc: "/assets/HomeLanding/QBIcons/candorfoods.svg",height:"10rem",width:"15rem",  altText: "CandorFoods" },
    { imgSrc: "/assets/HomeLanding/QBIcons/TirumalaTirupatiDevasthanams.svg",height:"10rem",width:"15rem",  altText: "TirumalaTirupatiDevasthanams" },
    { imgSrc: "/assets/HomeLanding/QBIcons/earthrhythm.svg",height:"10rem",width:"15rem",  altText: "ArthRhythm1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/hindustanunilever.svg",height:"10rem",width:"15rem",  altText: "HindustanUnileverLimited" },
    { imgSrc: "/assets/HomeLanding/QBIcons/genus.svg",height:"10rem",width:"15rem", altText: "Genus" },
    { imgSrc: "/assets/HomeLanding/QBIcons/dlfbrands.svg",height:"10rem",width:"15rem", altText: "DLFbrands" },
    { imgSrc: "/assets/HomeLanding/QBIcons/bayarscoffee.svg",height:"10rem",width:"15rem",  altText: "scoffee" },
    { imgSrc: "/assets/HomeLanding/QBIcons/continentalcoffee.svg",height:"10rem",width:"15rem", altText: "Continentalcoffee" },
    { imgSrc: "/assets/HomeLanding/QBIcons/plazalounge.svg",height:"10rem",width:"15rem", altText: "Plazapremiumlounge" },
    { imgSrc: "/assets/HomeLanding/QBIcons/mmmart.svg",height:"10rem",width:"15rem", altText: "Mart" },
    { imgSrc: "/assets/HomeLanding/QBIcons/wonderla.svg",height:"10rem",width:"15rem", altText: "wonderla" },
    { imgSrc: "/assets/HomeLanding/QBIcons/shivalaya1.svg",height:"10rem",width:"15rem", altText: "Shivalaya 1" },
    
   
]
const companyLogos2= [
     { imgSrc: "/assets/HomeLanding/QBIcons/organicharvest.svg", width:"15rem", height:"10rem", altText: "OrganicHarvest" },
    { imgSrc: "/assets/HomeLanding/QBIcons/nayara.svg",width:"15rem", height:"10rem", altText: "NayaraEnergy" },
    { imgSrc: "/assets/HomeLanding/QBIcons/premier.svg",height:"10rem",width:"15rem", altText: "Premier1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/orgalife.svg",height:"10rem",width:"15rem", altText: "Orgalife1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/smytten.svg",height:"10rem",width:"15rem", altText: "Smytten1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/flemingo.svg",height:"10rem",width:"15rem", altText: "Flemingo1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/aafarin.svg",height:"10rem",width:"15rem", altText: "Aafarin" },
    { imgSrc: "/assets/HomeLanding/QBIcons/redivy.svg",height:"10rem",width:"15rem", altText: "RedIvy1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/toscee.svg",height:"10rem",width:"15rem",  altText: "Toscee1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/jainshikanji.svg",height:"10rem",width:"15rem", altText: "Jainshikanji" },
    { imgSrc: "/assets/HomeLanding/QBIcons/34chowringlane.svg",height:"10rem",width:"15rem", altText: "34chowringheelane" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tangelo.svg",height:"10rem",width:"15rem", altText: "Tangelo1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/canabeans.svg",height:"10rem",width:"15rem", altText: "Canabeans1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/thegulatigroup.svg",height:"10rem",width:"15rem",altText: "gulatigroup" },
    { imgSrc: "/assets/HomeLanding/QBIcons/gullynetwork.svg", height:"10rem",width:"15rem", altText: "Gullynetwork1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/mcd.svg",height:"10rem",width:"15rem", altText: "MCD1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/phl.svg",height:"10rem",width:"15rem", altText: "PHL1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tistabene.svg",height:"10rem",width:"15rem", altText: "Tistabene1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/hokmakeup.svg",height:"10rem",width:"15rem", altText: "HOKmakeup1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/handfulofhealth.svg",height:"10rem",width:"15rem", altText: "Handfulofhealth" },
    { imgSrc: "/assets/HomeLanding/QBIcons/grihasthee.svg",height:"10rem",width:"15rem", altText: "grihasthee1" },
    // { imgSrc: "/assets/HomeLanding/QBIcons/relaxo.svg",height:"10rem",width:"15rem", altText: "relaxo" },
]
  


    return (
        <div style={{fontFamily:"GilroyMedium"}}>
            <HeroSection data={topSection} />
           <div style={{ maxWidth: "1850px", margin:"0 auto"}}>
              <div style={{ margin: "0rem 18rem 0 18rem", position: "relative", zIndex:1 }}>
                            <NewMarqueeComponentHomePageIndia
                             direction={'left'}
                                ClientsArr={CompanyLogos}
                                style={{
                                    width: "100%",
                                    backgroundColor: "transparent",
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "2rem auto",
                                }}
                            />
                            <NewMarqueeComponentHomePageIndia
                                ClientsArr={companyLogos2}
                                  
                                style={{
                                    width: "100%",
                                    backgroundColor: "transparent",
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "-3.5rem auto 0 auto",
                               
        
                                }}
                            />
                        </div>
           </div>

           <div className={styles.features_section}>
                <div className={styles.section_heading}><h1>Standout Features of  <span style={{color:"#2A6AB4"}}> QueueBuster POS for Watch Stores </span></h1>
                {/* <div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div> */}
                </div>

            
            <FeaturesSection data={watchStoreFeatures.data} centerImages={[watchStoreFeatures.centerImage2]} />
            </div>
            <div className={styles.featuresSection}>
                {/* <GetFreeTrial/> */}
                <div ><ReviewsSection /></div>
                <div><BusinessUnlockSection /></div>
                <div><CaseStudiesSection /></div>
                <div style={{ margin: "0 0rem 8rem 0rem " }}> <ConnectWithUs /></div>
                
                <NewFaqSection FaqTableData={faqs} heading ={"FAQ’s for the QueueBuster POS fashion watch stores"}  />
                <div >
                    <NewsAndVideos />
                </div>
            </div>

        </div>
    )
}


export default FashionWatchesStore
